import React, { useMemo } from "react";

function TimerCounter({ days, hours, minutes, seconds }: any) {
  const startTimer = useMemo(() => seconds || minutes || hours || days, [seconds, minutes, hours, days]);
  return (
    <div className="d-flex fw-bold" style={!startTimer ? { color: "transparent" } : {}}>
      {!!days && (
        <div className="timebox py-2 fw-bold mr-2">
          <span className="text-lg">{days}</span>
          <span className="">{days < 2 ? "Day" : "Days"}</span>
        </div>
      )}
      <div className="timebox py-2 fw-bold">
        <span className="text-lg">{hours}</span>
        <span className=""> {hours < 2 ? "Hr" : "Hrs"}</span>
      </div>
      <div className="timebox py-2 fw-bold mx-2">
        <span className="text-lg">{minutes}</span>
        <span className="">{minutes < 2 ? "Min" : "Mins"}</span>
      </div>
      {!days && (
        <div className="timebox py-2 fw-bold">
          <span className="text-lg">{seconds}</span>
          <span className="">{seconds < 2 ? "Sec" : "Secs"}</span>
        </div>
      )}
    </div>
  );
}

export default TimerCounter;
